import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Notification, NotificationType } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { IBlockedDirectLoadInfo } from '@epi-models/pages/TransferPage';

export const BlockedDirectLoadInfo = ({
  blockDirectLoad
}: IBlockedDirectLoadInfo) => {
  const { t } = useTranslation();
  const { fontBold } = useTheme();

  if (!blockDirectLoad) {
    return null;
  }

  return (
    <Notification
      id="blocked-directload-info"
      type={NotificationType.Info}
      text={
        <Box>
          <Box fontWeight={fontBold} display="inline" marginRight={0.5}>
            {t(
              'containers.deposit_money.topup_tab.blocked_directload_info.title'
            )}
          </Box>
          <Box display="inline">
            {t(
              'containers.deposit_money.topup_tab.blocked_directload_info.content'
            )}
          </Box>
        </Box>
      }
    />
  );
};
